import React from 'react';
import logo200Image from '../assets/img/logo/20200723_UnitySuiteSqLogo512.webp';
import { Button, Spinner } from 'reactstrap';
import queryString from 'query-string';
import { MdCheckCircle } from 'react-icons/md';
import axios from 'axios';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';

class VerifyUserPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      redirect: false,
    };
  }

  verify = params => {
    let email = params.email;
    let companyId = params.company;
    let requestKey = params.key;
    let service = params.service;

    const url = process.env.REACT_APP_API_URL;

    const data = {
      app_key: process.env.REACT_APP_KEY,
      CompanyID: companyId,
      Email: email,
      RequestKey: requestKey,
      Service: service,
    };

    axios
      .post(url + ':3000/v1/configuration/updateAuthorisedKey', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          loading: false,
        });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);

    if (params != null || params != undefined) {
      this.verify(params);
    }
  }
  render() {
    // if (this.state.redirect) {
    //   return <Redirect to="/organisation" />;
    // }

    return (
      <div className="ps-verify-msg">
        <div className="wrapper">
          <img
            src={logo200Image}
            width="100px"
            height="auto"
            className="pr-2"
            alt=""
          />
          <h2 className="text-white my-4">
            <span style={{ color: '#00adad', fontWeight: '600' }}>Unity</span>
            <span style={{ color: '#2a2c6b' }}>SuitePro</span>
          </h2>
          <div className="box-msg">
            <div>
              {this.state.loading ? (
                <>
                  <h4>We're verifying your account. . .</h4>
                  <p>Please don't refresh the page</p>
                  <Spinner animation="border" size="sm" />
                </>
              ) : (
                <>
                  <h4>
                    Account Verified{' '}
                    <MdCheckCircle
                      style={{ color: '#19bd73', fontWeight: '600' }}
                    />
                  </h4>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default VerifyUserPage;
